import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-delete-dialog',
  templateUrl: './delete-dialog.component.html',
  styleUrls: ['./delete-dialog.component.css']
})
export class DeleteDialogComponent implements OnInit {
  @Input() text: string;
  @Input() id: any;
  @Input() callback: any;

  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  async cancel() {
    //Close dialog
    await this.activeModal.close(undefined);
  }

  async ok() {
    //Close dialog
    await this.activeModal.close(undefined);
    if (typeof (this.callback) == 'function') this.callback();
  }

}
